module.exports = __webpack_public_path__ + "static/share-2f16031fb6c3b4e12dc6eca269d3e8ae.png";